


















import { Component, Vue, Watch } from "vue-property-decorator";

import EspressoAux from "@/components/Espresso/EspressoAux.vue";
import PaginatedSearch from "@/layouts/DashboardLayoutComponents/SoniprevPaginatedSearch.vue";
import CreationCard from "@/layouts/DashboardLayoutComponents/CreationCard.vue";

import HealthProfessionalModal from "./HealthProfessionalModal.vue";
import userModel from "@/models/user.model";

@Component({
	components: {
		PaginatedSearch,
		HealthProfessionalModal,
		CreationCard,
	},
})
export default class HealthProfessionals extends Vue {
	entityModel: any;
	userId: string = "";

	searchActions = [{ name: "Aprovar", icon: "done", color: "#489F63", action: this.approvePending }];
	professionalCreationFields = [
		{ key: "name", class: "md-size-50" },
		{ key: "email", class: "md-size-50" },
		{ key: "password", class: "md-size-50" },
	];

	constructor() {
		super();
		this.entityModel = userModel;
	}

	async mounted() {
		this.userId = this.$route.params.id;
	}

	openEntity(user: any) {
		this.$router.push(`/escalas/novos-profissionais-saude/${user.id}`);
	}

	async approvePending(user: any) {
		if (!(await EspressoAux.showConfirmationModal("Confirma a aprovação?")).value) {
			return;
		}
		try {
			await userModel.update(user.id, { status: "PENDING_CONTRACT" });
			this.$toasted.success("Candidatura aprovada");
			(this.$refs.paginatedSearch as any).refresh();
		} catch (error) {
			this.$toasted.error(error.friendlyMessage || "Erro ao aprovar. Tente novamente.");
			console.error(error);
		}
	}

	closeModal() {
		this.$router.push(".");
		(this.$refs.paginatedSearch as any).refresh();
	}

	@Watch("$route")
	updateRoute(route: any) {
		if (route.params.id) {
			this.userId = route.params.id;
		} else {
			this.userId = "";
		}
	}
}
